"use client";

import { c as _c } from "react/compiler-runtime";
import { api } from "@agroproj/backend/convex/_generated/api";
import { useUser } from "@clerk/nextjs";
import { useMutation } from "convex/react";
import { ConvexError } from "convex/values";
import { createContext, use, useState, type ReactNode } from "react";
import { toast } from "sonner";
import { LoadingPage } from "@/components/loading-page";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { standardFormDialogContentClassName } from "@/components/ui/dialog-content-styles";
import { SupportForm, type SupportFormValues, type SupportSubmitResult } from "./support-form";
const SupportDialogContext = createContext<(() => void) | null>(null);

/** Mounts the support dialog once for the app shell so the sidebar and user menu can open it. */
export function SupportDialogProvider(t0) {
  const $ = _c(8);
  const {
    children
  } = t0;
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setOpen(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DialogHeader><DialogTitle>Falar com o suporte</DialogTitle><DialogDescription>Responderemos pelo e-mail da sua conta.</DialogDescription></DialogHeader>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DialogContent className={standardFormDialogContentClassName}>{t2}<SupportDialogForm onClose={() => setOpen(false)} /></DialogContent>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== open) {
    t4 = <Dialog onOpenChange={setOpen} open={open}>{t3}</Dialog>;
    $[3] = open;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children || $[6] !== t4) {
    t5 = <SupportDialogContext value={t1}>{children}{t4}</SupportDialogContext>;
    $[5] = children;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}

/** Returns the opener for the app shell's support dialog. */
export function useOpenSupportDialog() {
  const openSupportDialog = use(SupportDialogContext);
  if (!openSupportDialog) {
    throw new Error("useOpenSupportDialog must be used within SupportDialogProvider");
  }
  return openSupportDialog;
}
function SupportDialogForm(t0) {
  const $ = _c(13);
  const {
    onClose
  } = t0;
  const {
    user
  } = useUser();
  const createTicket = useMutation(api.support.mutations.createTicket);
  if (!user) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <LoadingPage />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== createTicket) {
    t1 = async t2 => {
      const {
        subject,
        message
      } = t2;
      ;
      try {
        await createTicket({
          subject,
          message
        });
        return {
          ok: true
        };
      } catch (t3) {
        const error = t3;
        return {
          ok: false,
          message: error instanceof ConvexError && typeof error.data === "string" ? error.data : "N\xE3o foi poss\xEDvel enviar a mensagem. Tente novamente."
        };
      }
    };
    $[1] = createTicket;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const submit = t1;
  const t2 = user.fullName ?? "";
  const t3 = user.primaryEmailAddress?.emailAddress ?? "";
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = {
      name: t2,
      email: t3
    };
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== onClose) {
    t5 = () => {
      onClose();
      toast.success("Mensagem enviada ao suporte");
    };
    $[6] = onClose;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== onClose || $[9] !== submit || $[10] !== t4 || $[11] !== t5) {
    t6 = <SupportForm identity={t4} onCancel={onClose} onSubmit={submit} onSuccess={t5} surface="app" />;
    $[8] = onClose;
    $[9] = submit;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}